// @flow

import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';

import type { Observable } from '../../';

ko.bindingHandlers.nonDropableOptionsCaption = {

	after: ["optionsCaption"],

	//eslint-disable-next-line max-len
	init: function (element, valueAccessor: ?boolean | Observable<boolean>, allBindings, viewModel, bindingContext) {
		if (ko.utils.tagNameLower(element) !== "select"){
			throw new Error("'nonDropableOptionsCaption' binding applies only to SELECT elements");
		}

		if (!allBindings['has']('optionsCaption')){
			//eslint-disable-next-line max-len
			throw new Error("'nonDropableOptionsCaption' binding works only on element binded with 'optionsCaption'");
		}

		const optionsCaptionElement = $(element).find('option')[0];

		ko.applyBindingsToNode(optionsCaptionElement,
			{attr: {hidden: !_.isNil(valueAccessor()) ? valueAccessor() : true}},
			bindingContext);
	},
};